<template>
  <div>
    <titulo-modulo
      :titulo="$route.params.id > 0 ? 'Editar Atestado' : 'Enviar Atestado'"
    />
    <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
    <v-row v-else>
      <v-col class="pt-0">
        <v-btn rounded color="error" :to="{ name: 'atestados' }" max-height="35"
          >Cancelar</v-btn
        >
      </v-col>
      <v-col cols="12" class="pt-0" v-if="podeEditar">
        <v-stepper v-model="stepModel" vertical class="mt-2">
          <selecionar-tipo-atestado />
          <selecionar-motivos-atestado />
          <template v-if="step > 10">
            <selecionar-dependente v-if="getTipoSelecionado().infdependente" />
            <informar-datas v-if="getTipoSelecionado().infdatas" />
            <dados-cid v-if="getTipoSelecionado().infcid" />
            <dados-medicos v-if="getTipoSelecionado().infmedico" />
          </template>
          <dados-adicionais />
          <anexar-documentos />
        </v-stepper>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import TituloModulo from "../../../components/TituloModulo.vue";
import SelecionarDependente from "./components/SelecionarDependente.vue";
import SelecionarMotivosAtestado from "./components/SelecionarMotivosAtestado.vue";
import SelecionarTipoAtestado from "./components/SelecionarTipoAtestado.vue";
import InformarDatas from "./components/InformarDatas.vue";
import DadosCid from "@/views/atestados/enviar-atestado/components/DadosCID.vue";
import DadosMedicos from "./components/DadosMedicos.vue";
import DadosAdicionais from "./components/DadosAdicionais.vue";
import AnexarDocumentos from "./components/StepAnexarDocumentos.vue";
import moment from "moment";

export default {
  computed: {
    ...mapState("atestado", [
      "step",
      "atestadoEnviar",
      "configs",
      "screens",
      "atestados",
      "atestSelec",
    ]),
    stepModel: {
      get: function () {
        return this.step;
      },
      set: function (value) {
        this.setStep(value);
      },
    },
  },
  components: {
    TituloModulo,
    SelecionarMotivosAtestado,
    SelecionarDependente,
    SelecionarTipoAtestado,
    InformarDatas,
    DadosCid,
    DadosMedicos,
    DadosAdicionais,
    AnexarDocumentos,
  },
  data: () => ({
    carregando: false,
    podeEditar: true,
  }),
  methods: {
    ...mapMutations("atestado", [
      "setStep",
      "setScreens",
      "setAtestSelec",
      "setScreen",
      "setDados",
    ]),
    ...mapMutations("anexos", ["setDocs"]),
    ...mapActions("atestado", ["getConfigs", "getCIDS", "getAtestados"]),
    ...mapActions("dependentes", ["getDependentes"]),
    ...mapGetters("atestado", ["getTipoSelecionado"]),
  },
  async mounted() {
    this.carregando = true;
    this.setDados("ATESTADOS");
    await this.getConfigs();
    await this.getDependentes("atestado");
    await this.getCIDS();
    this.setScreens();
    this.setStep(this.screens[0]);
    if (this.$route.params.id > 0) {
      await this.getAtestados();

      this.setAtestSelec(
        this.atestados.find(
          (atest) => atest.codigo == this.$route.params.id && atest.status === 2
        )
      );

      if (this.atestSelec) {
        this.atestadoEnviar.tipo = this.atestSelec.codconfigatest;
        this.atestadoEnviar.motivo = this.atestSelec.codconfigsituacao;
        this.atestadoEnviar.dependente = this.atestSelec.coddependente;
        this.atestadoEnviar.datainicial = this.atestSelec.datainicio;
        this.atestadoEnviar.diasatestado = this.atestSelec.diasatestado;
        this.atestadoEnviar.datafinal = this.atestSelec.datafim;
        this.atestadoEnviar.cid = this.atestSelec.cid;
        this.atestadoEnviar.codMedico = this.atestSelec.codmedico;
        this.atestadoEnviar.nomeMedico = this.atestSelec.medico;
        this.atestadoEnviar.crmcro = this.atestSelec.crmcro;
        this.atestadoEnviar.ddd = this.atestSelec.foneddd;
        this.atestadoEnviar.telefone = this.atestSelec.fonenumero;
        this.atestadoEnviar.justificativa = this.atestSelec.justificativa;
        this.setDocs(this.atestSelec.anexos);
      } else this.podeEditar = false;

      //this.atestadoEnviar.telefone = this.atestSelec.fonenumero;
    } else {
      this.setAtestSelec(null);
      this.setScreen(0);
      this.atestadoEnviar.tipo = 0;
      this.atestadoEnviar.motivo = 0;
      this.atestadoEnviar.dependente = 0;
      this.atestadoEnviar.datainicial = moment().format("YYYY-MM-DD");
      this.atestadoEnviar.diasatestado = 1;
      this.atestadoEnviar.datafinal = moment().format("YYYY-MM-DD");
      this.atestadoEnviar.cid = "";
      this.atestadoEnviar.codMedico = 0;
      this.atestadoEnviar.nomeMedico = "";
      this.atestadoEnviar.crmcro = "";
      this.atestadoEnviar.ddd = "";
      this.atestadoEnviar.telefone = "";
      this.atestadoEnviar.justificativa = "";
      this.setDocs([]);
    }
    this.carregando = false;
  },
};
</script>


    